export const UserTypes = {
    mobileUsers: 'mobUser',
    cmsUsers: 'cms',
    all: 'all',
    admin:'admin',
    portalUser:'portalUser'
}
